'use strict'

import React from 'react'
import FAQ   from '../assets/faq'
import Modal from '../assets/modal'

export default class CustomerServiceDetails extends React.Component {
  constructor () {
    super(...arguments)

    this.state = {
      modalOpened: false
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal (e) {
    e.preventDefault()
    this.setState({ modalOpened: true })
  }

  closeModal () {
    this.setState({ modalOpened: false })
  }

  render () {
    const { modalOpened } = this.state

    return (
      <div>
        <section className='customer-service-details'>
          <h2>Customer Service Details</h2>
          <div>
            <div className='input-row'>
              <span className='item-title half-width'>Phone</span>
              <span className='half-width medium-text text-primary'>1300 787 356</span>
            </div>
            <div className='input-row'>
              <span className='item-title half-width'>Email</span>
              <span className='half-width medium-text text-primary'>info@dentalmembers.com.au</span>
            </div>
            <div className='input-row'>
              <span className='item-title half-width align-top'>Address</span>
              <span className='half-width medium-text text-primary'>Unit 11/31 Springfields Lake blvd<br /> Springfields Lake Wld 4300</span>
            </div>
          </div>
        </section>
        <br />
        <button className='pointer faq-button' onClick={this.openModal}>
          FAQs
        </button>
        <Modal content={<FAQ />} opened={modalOpened} onClose={this.closeModal} />
        <br />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/customer-service-details.js